import styled from "styled-components";

function GradientText(props) {

  let direction
  //case switch
  switch (props.to) {
    case "right":
      direction = "90";
      break
    case "left":
      direction = "270";
      break
    default:
      direction = props.to;
      break
  }

  const Gradient = styled.span`
    background: linear-gradient(
      ${direction}deg,
      ${props.color1 ? props.color1 : "#E662F1"} ${props.start ? props.start + '%' : '0%'},
       ${props.color2 ? props.color2 : "#F39D6C"} ${props.stop ? props.stop + '%' : '100%'}
      );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    /* box-decoration-break: clone;
    -webkit-box-decoration-break: clone; */

    /* filter: saturate(0.85); */

  `

  return (

    <Gradient>
      {props.children}
    </Gradient>

  )
}

export default GradientText